import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ThePathToPeace from "./sections/ThePathToPeace";
import HandsOffHarmony from "./sections/HandsOffHarmony";
import SmartNestOperations from "./sections/SmartNestOperations";
import WarmMinimalist from "./sections/WarmMinimalist";
import IndustryVoices from "./sections/IndustryVoices";
import CommonQuestions from "./sections/CommonQuestions";
import ReadyToScale from "./sections/ReadyToScale";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ThePathToPeace />
      <HandsOffHarmony />
      <SmartNestOperations />
      <WarmMinimalist />
      <IndustryVoices />
      <CommonQuestions />
      <ReadyToScale />
      <Footer />
    </div>;
}